module.exports = __webpack_public_path__ + "img/x_ray_2.75239124.png";